module.exports = __webpack_public_path__ + "img/appleDw.65a176eb.svg";